export default __webpack_public_path__ + "static/media/Soulace_Brochure.ba9c1108.pdf";